export enum ContactInfo {
  API_IMPLEMENTATION = 'API Implementation contact',
  TECH_DECISION = 'Technical Decision maker',
  TECH_SUPPORT = 'Technical Support contact',
  BILLING = 'Billing contact',
}
